import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import * as orderActions from "../../actions/orderActions";
import OrderView from '../../components/Customer/Order/OrderView';
import {Link} from 'react-router-dom';
import {translate} from "react-i18next";
import ReactDOM from "react-dom";
import {List} from 'immutable';


class OrderLayout extends Component {

  constructor(props) {
    super(props);
    this.moreOrders = this.moreOrders.bind(this);
    this.lessOrders = this.lessOrders.bind(this);
    this.refOrderFirst = React.createRef();
  }

  componentDidMount() {
    this.props.getOrders();
  }

  moreOrders(e) {
    e.preventDefault();
    this.props.startFetchOrders();
    this.props.getOrders({limit: 'all'}).then(() => {
      this.props.endFetchOrders();
    });
  }

  lessOrders(e) {
    e.preventDefault();
    this.props.getOrders().then(() => {
      const formNode = ReactDOM.findDOMNode(this.refOrderFirst.current);
      formNode.scrollIntoView(true);
    });
  }

  render() {
    const {orders, language, ingredients, t} = this.props;
    const {moreOrders, lessOrders, refOrderFirst} = this;
    const orderData = orders.get('data') || List();
    return (
      <div>
        <OrderView
          list={orderData.toJS()}
          language={language}
          ingredients={ingredients.toArray()}
          moreOrders={moreOrders}
          lessOrders={lessOrders}
          refFirstOrder={refOrderFirst}
        />
        <div className='order__more'>
          {orderData.size === 3 && orders.get('total') > 3 &&
            <Link to='#' onClick={e => this.moreOrders(e)}>{t('show_more_orders')}</Link>
          }
          {orderData.size > 3 &&
            <Link to='#' onClick={e => this.lessOrders(e)}>{t('show_less_orders')}</Link>
          }
        </div>
      </div>
    );
  }
}


OrderLayout.propTypes = {
  orders: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getOrders: PropTypes.func,
  ingredients: PropTypes.object,
  lessOrders: PropTypes.func,
  moreOrders: PropTypes.func
};

function mapStateToProps(state) {
  return {
    orders: state.order.get('list'),
    language: state.language.defaultLanguage,
    ingredients: state.products.ingredients
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getOrders: bindActionCreators(orderActions.getOrders, dispatch),
    startFetchOrders: bindActionCreators(orderActions.startFetchOrders, dispatch),
    endFetchOrders: bindActionCreators(orderActions.endFetchOrders, dispatch),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(translate('translations')(OrderLayout));


// WEBPACK FOOTER //
// ./src/containers/Customer/Order.js